import { render, staticRenderFns } from "./lucky-cards.vue?vue&type=template&id=7286fec3&scoped=true&"
import script from "./lucky-cards.vue?vue&type=script&lang=js&"
export * from "./lucky-cards.vue?vue&type=script&lang=js&"
import style0 from "./lucky-cards.vue?vue&type=style&index=0&id=7286fec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7286fec3",
  null
  
)

export default component.exports